<div *ngIf="isLoading" class="spinner-container">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="md:w-30rem">
  <form [formGroup]="registerForm">
    <app-step-rol
      *ngIf="formStep === 1"
      (rol)="reciveData($event)"
    ></app-step-rol>

    <ng-container *ngIf="selectedRol">
      <app-step-personal-information
        *ngIf="
          (selectedRol === 'Trabajador' && formStep === 2) ||
          (selectedRol === 'Empleador' && formStep === 5) ||
          (selectedRol === 'Representante gremial' && formStep === 3)
        "
        [initialData]="registerForm.value"
        (personales)="reciveData($event)"
        (back)="previousStep($event)"
        [selectedRol]="registerForm.get('rol')?.value"
      ></app-step-personal-information>

      <app-step-location
        *ngIf="
          (selectedRol === 'Trabajador' && formStep === 3) ||
          (selectedRol === 'Empleador' && formStep === 6) ||
          (selectedRol === 'Representante gremial' && formStep === 4)
        "
        [initialData]="registerForm.value"
        (location)="reciveData($event)"
        (back)="previousStep($event)"
        [selectedRol]="registerForm.get('rol')?.value"
      ></app-step-location>

      <app-step-mail-password
        *ngIf="
          (selectedRol === 'Trabajador' && formStep === 4) ||
          (selectedRol === 'Empleador' && formStep === 7) ||
          (selectedRol === 'Representante gremial' && formStep === 6)
        "
        [initialData]="registerForm.value"
        (emailPassword)="register($event)"
        (back)="previousStep($event)"
        [selectedRol]="registerForm.get('rol')?.value"
      ></app-step-mail-password>

      <app-step-mail-validation
        *ngIf="
          (selectedRol === 'Trabajador' && formStep === 5) ||
          (selectedRol === 'Empleador' && formStep === 8) ||
          (selectedRol === 'Representante gremial' && formStep === 7)
        "
        [selectedRol]="registerForm.get('rol')?.value"
      ></app-step-mail-validation>

      <app-typeResponsibility
        *ngIf="
          (selectedRol === 'Empleador' && formStep === 2) ||
          (selectedRol === 'Representante gremial' && formStep === 2)
        "
        [initialData]="registerForm.value"
        [selectedRol]="registerForm.get('rol')?.value"
        (act)="reciveData($event)"
        (back)="previousStep($event)"
      ></app-typeResponsibility>

      <app-step-company-cuil
        *ngIf="selectedRol === 'Empleador' && formStep === 3"
        [initialData]="registerForm.value"
        (company)="reciveData($event)"
        (companySearch)="reciveCompany($event)"
        (back)="previousStep($event)"
        [selectedRol]="registerForm.get('rol')?.value"
      ></app-step-company-cuil>

      <app-step-company-form
        *ngIf="selectedRol === 'Empleador' && formStep === 4"
        [CompanyData]="searchedCompanyData"
        (company)="checkCompany($event)"
        (back)="previousStep($event)"
        [selectedRol]="registerForm.get('rol')?.value"
        [messageCompany]="messageCompany"
        [isNewCompany]="isNewCompany"
      >
      </app-step-company-form>

      <app-step-two-inputs
        *ngIf="selectedRol === 'Representante gremial' && formStep === 5"
        [selectedRol]="selectedRol"
        [selectedeDoYouAct]="selectedTypeResponsibility"
        [initialData]="registerForm.value"
        (data)="reciveData($event)"
        (back)="previousStep($event)"
      ></app-step-two-inputs>

      <ng-container *ngIf="isStepValid()">
        <div class="grid">
          <div class="col-10">
            <div class="stepper">
              <div
                *ngFor="let step of getSteps(); let i = index"
                [class.step]="true"
                [class.active]="formStep === step"
              ></div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </form>
</div>

<p-toast></p-toast>
